export enum PasswordResetFormNames {
    CONFIRM_PASSWORD = "confirmPassword",
    PASSWORD = "password",
}

export type PasswordResetFormData = Record<PasswordResetFormNames, string>;
